import { MasterCompArrayFormClientsEffects } from '../../comp-array-form-clients/store';
import { MasterConfirmedMessageEffects } from '../../confirmed-message/store';
import { MasterPerfilUsuarioEffects } from '../../perfil-usuario/store';
import { MasterSearchUserEffects } from '../../search-user/store';
import { MasterVisualizarUsuarioEffects } from '../../visualizar-usuario/store';
import { MasterAccessProfileEffects } from '../../access-profile/store';
import { MasterConsultaClientesEffects } from '../../consulta-clientes/store';
import { MasterConsultaUsuariosEffects } from '../../consulta-usuarios/store';
import { MasterCreateUserWizardEffects } from '../../create-user-wizard/store';
import { MasterCreateUserEffects } from '../../create-user/store';
import { MasterEdit0Effects } from '../../edit-0/store';
import { MasterEdit1Effects } from '../../edit-1/store';
import { MasterEdit5Effects } from '../../edit-5/store';
import { MasterFundosEffects } from '../../fundos/store';
import { MasterMasterHomeEffects } from '../../master-home/store';
import { MasterPerfilAcessoEffects } from '../../perfil-acesso/store';
import { MasterSearch0Effects } from '../../search-0/store';
import { MasterSearch1Effects } from '../../search-1/store';

export const effects: any[] = [
  MasterCompArrayFormClientsEffects,
  MasterConfirmedMessageEffects,
  MasterPerfilUsuarioEffects,
  MasterSearchUserEffects,
  MasterVisualizarUsuarioEffects,
  MasterAccessProfileEffects,
  MasterConsultaClientesEffects,
  MasterConsultaUsuariosEffects,
  MasterCreateUserWizardEffects,
  MasterCreateUserEffects,
  MasterEdit0Effects,
  MasterEdit1Effects,
  MasterEdit5Effects,
  MasterFundosEffects,
  MasterMasterHomeEffects,
  MasterPerfilAcessoEffects,
  MasterSearch0Effects,
  MasterSearch1Effects,
];
